import { ListItem, ListItemProps, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function UnknownBeneficiaryListItemContent() {
  const { t } = useTranslation();
  return <ListItemText primary={t('Unknown')} />;
}

export function UnknownBeneficiaryListItem(props: ListItemProps) {
  return (
    <ListItem {...props}>
      <UnknownBeneficiaryListItemContent />
    </ListItem>
  );
}
